import React, { useEffect, useState ,useContext} from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ThemeContext } from "../../../Shared/Themes/ThemeContext";
import { baseURL } from '../../../Apiservices/Api';
import Navbar from "../../../Shared/Navbar/Navbar";
import './EditSupplier.css';

const EditSupplier = () => {
      const [collapsed, setCollapsed] = useState(false);
      const { themeColor } = useContext(ThemeContext);
      const [message, setMessage] = useState("");
      const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    supplierName: "",
    companyName: "",
    contactPerson: "",
    phone: "",
    email: "",
    address: ""
  });

  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  // Fetch supplier data on mount
  useEffect(() => {
    const fetchSupplier = async () => {
      try {
        const res = await fetch(`${baseURL}/api/supplierslist/${id}`);
        const result = await res.json();
        if (result.success) {
          const { supplierName, companyName, contactPerson, phone, email, address } = result.data;
          setFormData({ supplierName, companyName, contactPerson, phone, email, address });
        } else {
          alert("Failed to load supplier details.");
        }
      } catch (error) {
        console.error(error);
        alert("Error fetching supplier.");
      }
    };

    fetchSupplier();
  }, [id]);

  // Input change handler
  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // Submit handler
  const handleSubmit = async (e, action) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${baseURL}/api/edit-supplierslist/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      const result = await res.json();
      if (result.success) {
        setMessage("Lead added successfully!");
        if (action === "saveAndClose") navigate(-1);
      } else {
        setError("Failed to update supplier.");
      }
    } catch (error) {
      console.error(error);
      setError("Error updating supplier.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="suppliercontainer">
    <Navbar onToggleSidebar={setCollapsed} />
    <div className={`ViewSupplier ${collapsed ? "collapsed" : ""}`}>
    <form onSubmit={(e) => handleSubmit(e, "save")} className="editsupplier-form">
    <h2 className="supplier-form-header" style={{ "--theme-color": themeColor }}>Edit Supplier</h2>
    {error && <div className="alert alert-danger">{error}</div>}
          {message && <div className="alert alert-info">{message}</div>}
      <div className="editsupplier-form-grid mb-3">
        <div className="editsupplier-input-group">
          <label>Supplier Name</label>
          <input
            type="text"
            name="supplierName"
            value={formData.supplierName}
            onChange={handleChange}
            placeholder="Enter Supplier Name"
          />
        </div>

        <div className="editsupplier-input-group">
          <label>Company Name</label>
          <input
            type="text"
            name="companyName"
            value={formData.companyName}
            onChange={handleChange}
            placeholder="Enter Company Name"
          />
        </div>

        <div className="editsupplier-input-group">
          <label>Contact Person</label>
          <input
            type="text"
            name="contactPerson"
            value={formData.contactPerson}
            onChange={handleChange}
            placeholder="Enter Contact Person"
          />
        </div>

        <div className="editsupplier-input-group">
          <label>Phone</label>
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Enter Phone Number"
          />
        </div>

        <div className="editsupplier-input-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter Email"
          />
        </div>

        <div className="editsupplier-input-group ">
          <label>Address</label>
          <input
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Enter Address"
          />
        </div>
      </div>

      <div className="editsupplier-form-footer">
        <button className="btn btn-secondary" type="button" onClick={() => navigate(-1)}>
          Back
        </button>
        {/* <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? "Saving..." : "Save"}
        </button> */}
        <button
          className="btn btn-success"
          type="button"
          onClick={(e) => handleSubmit(e, "saveAndClose")}
          disabled={loading}
        >
          {loading ? "Saving..." : "Save & Close"}
        </button>
      </div>
    </form>
    </div>
    </div>
  );
};

export default EditSupplier;
